import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchRecommendation, submitSurveyForm } from "../../apiServices";
import {
  TERMS_AND_CONDITIONS_URL,
  PRIVACY_POLICY_URL,
  CIGNA_URL,
} from "../../constants";
import "./SurveyForm.scss";

const SurveyForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { responseId: newReviewEmailId } = useParams();

  const [loader, setLoader] = useState(false);
  const [review, setReview] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recommendation, setRecommendation] = useState("");
  const [crmProviderNameSubject, setCrmProviderNameSubject] = useState("");
  const [reviewEmailId, setReviewEmailId] = useState("");
  const [relationship, setRelationship] = useState("");
  const [recommend, setRecommend] = useState("");

  // const testUrl =
  //   "https://reviews.cigna.com/reviews/pcv2/response/3621b76d-43d8-4769-a6b3-ab01d6564a37?rec=0&EID=EM_06_616&relationship=patient&Lead_Key_ID=231841652184";

  useEffect(() => {
    let newRecommend = "";

    let newRelationship = "";

    const searchParams = new URLSearchParams(location.search);
    newRelationship = searchParams.get("relationship") || "";
    const recParam = searchParams.get("rec");
    newRecommend = recParam === "1" ? true : recParam === "0" ? false : "";

    setRecommend(newRecommend);
    setRecommendation(newRecommend ? "Yes" : "No");
    setRelationship(newRelationship);

    if (
      typeof newRecommend === "boolean" &&
      newRelationship &&
      newReviewEmailId
    ) {
      const performRecomendationFetch = async () => {
        try {
          setLoader(true);
          const response = await fetchRecommendation({
            recommend: newRecommend,
            relationship: newRelationship,
            reviewEmailId: newReviewEmailId,
          });
          console.log("Recommendation Response:", response);
          if (response.isReviewComplete) {
            navigate("/review-completed");
          } else {
            setCrmProviderNameSubject(response.crmProviderNameSubject);
            setReviewEmailId(response.reviewEmailId);
            setRecommend(response.isRecommended);
            setRecommendation(response.isRecommended ? "Yes" : "No");
          }
        } catch (error) {
          console.log(error);
          if (
            error?.status === 400 &&
            error?.response?.data?.metadata?.outcome?.additionalDetails?.[0]
              ?.innerError === "Reviewed by alternate user"
          ) {
            navigate("/review-completed");
            return;
          }
          navigate("/error");
        }
        setLoader(false);
      };
      performRecomendationFetch();
    }
  }, [location.pathname, location.search]);

  const handleReviewChange = (event) => {
    setReview(event.target.value);
  };

  const handleRecommendationChange = (event) => {
    setRecommendation(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await submitSurveyForm({
        reviewEmailId,
        relationship,
        comment: review,
        recommend,
      });
      setReview("");
      setRecommendation("");
      navigate("/completed");
    } catch (err) {
      console.log(err);
      navigate("/error");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loader) {
    return null;
  }

  return (
    <div className="survey-form-wrapper">
      <div className="container-fluid surveyForm-container">
        <div className="container main-layout">
          <div className="card parent-content">
            <div className="logo-header d-flex align-items-center">
              <img
                src="https://d3ppyoxr8wczcq.cloudfront.net/images/oct2017/cigna-logo.svg"
                alt="Cigna Logo"
                className="logo-img"
              />
            </div>
            <div className="survey-container">
              {" "}
              <h1>
                {`Do you recommend ${crmProviderNameSubject} to your family and
                friends?`}
              </h1>
              <form onSubmit={handleSubmit}>
                <fieldset name="surveyForm">
                  <div className="d-flex">
                    <div className="form-check">
                      <input
                        type="radio"
                        id="Yes"
                        name="recommendation"
                        value="Yes"
                        className="form-check-input"
                        checked={recommendation === "Yes"}
                        onChange={handleRecommendationChange}
                      />
                      <label htmlFor="Yes" className="form-check-label">
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="radio"
                        id="No"
                        name="recommendation"
                        value="No"
                        className="form-check-input"
                        checked={recommendation === "No"}
                        onChange={handleRecommendationChange}
                      />
                      <label htmlFor="No" className="form-check-label">
                        No
                      </label>
                    </div>
                  </div>

                  <div className="write-review-block">
                    <h2 className="font-weight-bold leftAlign">
                      Write a review
                    </h2>
                    <textarea
                      className="form-control"
                      placeholder={`Please tell us a little more about your visit with ${crmProviderNameSubject}. Your review helps other Cigna customers choose the best healthcare providers.`}
                      maxLength="2000"
                      rows="5"
                      value={review}
                      onChange={handleReviewChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className={`submitButton btn ${
                      review.trim() ? "btn-primary" : "btn-secondary"
                    } custom-margin custom-width`}
                    disabled={!review.trim() || isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-warpper">
        <div className="container footer">
          <p className="footerParaText">
            Your review will be displayed on myCigna for other patients to see
            when choosing a healthcare provider. While your name will not be
            included, basic demographic information (such as age range and
            gender) may be.
          </p>
          <p className="secondParaText">
            This does not supplement or replace Cigna's current complaint and
            quality monitoring process. For any specific issues or concerns that
            you would like to share with Cigna for further review, please call
            1.800.Cigna24 or 1.800.244.6224.
          </p>
          <div className="reviewLinks mb-2">
            <a
              href={CIGNA_URL}
              target="_blank"
              className="recommendReviewLinks"
              rel="noreferrer"
            >
              Cigna
            </a>
            <span>|</span>
            <a
              href={TERMS_AND_CONDITIONS_URL}
              target="_blank"
              className="recommendReviewLinks"
              rel="noreferrer"
            >
              Terms and Conditions
            </a>
            <span>|</span>
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              className="recommendReviewLinks"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyForm;
